"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayTimeoutError = exports.BadGatewayError = exports.InternalServerError = exports.NotFoundError = exports.ExpiredSecretError = exports.InvalidSecretError = exports.InvalidParameterError = exports.GenericError = void 0;
const core_1 = require("@smash-sdk/core");
class GenericError extends core_1.SDKError {
}
exports.GenericError = GenericError;
class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
exports.InvalidParameterError = InvalidParameterError;
class InvalidSecretError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidSecretError";
    }
}
exports.InvalidSecretError = InvalidSecretError;
class ExpiredSecretError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ExpiredSecretError";
    }
}
exports.ExpiredSecretError = ExpiredSecretError;
class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
exports.NotFoundError = NotFoundError;
class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
exports.InternalServerError = InternalServerError;
class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
exports.BadGatewayError = BadGatewayError;
class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
exports.GatewayTimeoutError = GatewayTimeoutError;
exports.default = {
    GenericError,
    InvalidParameterError,
    InvalidSecretError,
    ExpiredSecretError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
